/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-12 15:00:46                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-02-13 16:40:23                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * PlanningDrawer: planning drawer container
*/

/* Imports */
import { XMarkIcon } from "@heroicons/react/24/solid";
import React from "react";
/***/

/**
* PlanningDrawer: planning drawer container
* @param open - open state
* @param children - child component to print
* @param onClose - on close event
*/
export default function PlanningDrawer({
  open = false,
  children,
  onClose
}: {
  open?: boolean,
  children?: React.ReactNode,
  onClose?: () => void
}) {
  return(
    <div className={`planning-drawer ${open && "open"}`}>
      {onClose &&
        <button className="close-button" onClick={() => onClose()}>
          <XMarkIcon className="w-4"/>
        </button>
      }

      {children}
    </div>
  );
}
/***/
